export default "__VITE_ASSET__cce43524__"